import CountryCatalogue from "./CountryCatalogueContainer";

export default CountryCatalogue;
